import { render, staticRenderFns } from "./CustomerAddrField.vue?vue&type=template&id=8e0dfbde"
import script from "./CustomerAddrField.vue?vue&type=script&lang=js"
export * from "./CustomerAddrField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports